import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';

import { IVeiculo } from '../model/veiculo.model';

@Injectable()
export class VeiculoService extends EntityService<IVeiculo> {
  protected entityName = 'veiculo';
  constructor(protected configService: ConfigService) {
    super(
      {
        baseEntityEndPoint: 'veiculo',
        urlBackend: configService.backendURL
      }
    );
  }
}
